import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  remarkText: {
    fontSize: "11px",
    marginTop: "20px",
  },
}));
